function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.9081 1.05523C19.3732 0.382615 17.6268 0.382617 16.0919 1.05524L2.39458 7.05735C0.939778 7.69484 0 9.1327 0 10.721V23.782C0 24.4206 0.517671 24.9383 1.15625 24.9383C1.79483 24.9383 2.3125 24.4206 2.3125 23.782V11.6854L6.9375 13.4649V23.5467C6.9375 23.9682 7.14752 24.362 7.49756 24.5968C7.49756 24.5968 12.511 27.9383 18.5 27.9383C24.489 27.9383 29.5024 24.5968 29.5024 24.5968C29.8525 24.362 30.0625 23.9682 30.0625 23.5467V13.4649L35.708 11.3008C36.4862 11.0025 37 10.2553 37 9.42188C37 8.62283 36.5272 7.89948 35.7954 7.57878L20.9081 1.05523ZM17.2978 3.25439C18.0642 2.91918 18.9358 2.91918 19.7022 3.25439L33.7119 9.38197L19.5725 14.7944C18.8819 15.0587 18.1181 15.0587 17.4275 14.7944L3.28809 9.38197L17.2978 3.25439ZM9.25 14.3448L16.3536 17.0704C17.7356 17.6006 19.2647 17.6014 20.6471 17.0724L27.75 14.3547V22.6986C26.9912 23.1633 23.1973 25.4074 18.5 25.4074C13.8027 25.4074 10.0088 23.1633 9.25 22.6986V14.3448ZM1.15625 27.4691C0.514892 27.4691 0 28.0327 0 28.7346C0 29.4365 0.514892 30 1.15625 30C1.79761 30 2.3125 29.4365 2.3125 28.7346C2.3125 28.0327 1.79761 27.4691 1.15625 27.4691Z",
  fill: "#3080EA"
});

const SvgTraining = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 37,
    height: 30,
    viewBox: "0 0 37 30",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgTraining, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/training.e1238852.svg";
export { ForwardRef as ReactComponent };